import marketingPagesMap from '../config/marketing_pages.json'
const marketingApiUrl = process.env.VUE_APP_API_MARKETING_URL
const marketingApiKey = process.env.VUE_APP_API_MARKETING_AUTHORIZATION_KEY

export default {
  getMarketingRequest: function (name)
  {
    const axios = require('axios').default
    if (marketingApiKey)
    {
      return axios.get(marketingApiUrl + '/api/pages/' + this.getIdByName(name),
        {
          headers: {
            Authorization: 'Basic ' + marketingApiKey
          }
        })
    }

    return null
  },
  getIdByName: function (name)
  {
    if (marketingPagesMap && marketingPagesMap[name])
    {
      return marketingPagesMap[name]
    }
    else
    {
      console.error(name + ' not found in marketing api pages')
    }
  },
  parseContent: function (response)
  {
    if (response && response.data && response.data.page && response.data.page.customHtml)
    {
      const customHtml = response.data.page.customHtml
      const pattern = /<body[^>]*>((.|[\n\r])*)<\/body>/im
      const bodyContentMatches = pattern.exec(customHtml)
      if (bodyContentMatches && bodyContentMatches[1]) {
        return bodyContentMatches[1]
      }
    }
    return ''
  }
}
